import {
	CustomerController,
	TransactionsController,
	SettingsController,
} from '../../controllers';
import { customerStore, transactionStore, userStore } from '../../stores';
import Transactions from '../../pages/Transactions/Transactions';
import { theYear } from '../../utils/utils';
import React, { useEffect, useState } from 'react';
import { observer } from 'mobx-react';
import { object, string } from 'yup';
import moment from 'moment';
import { getDate } from '../../utils/utils';
import { filterPeriods } from '../../utils/utils';

const { transactions, transactionSummary } =
	TransactionsController;

const TransactionsContainer = () => {
	const [loading, setLoading] = useState(false);
	const [filterPeriod, setFilterPeriod] = useState(`${theYear}`);
	const [openExpensesModal, setOpenExpensesModal] = useState(false);
	const [openIncome, setOpenIncome] = useState(false);
	const setCustomers = async () => {
		if (
			customerStore.customers.length === 0 &&
			userStore.isOnBoardingDone !== 'false'
		) {
			await CustomerController.getCustomers();
		}
		return customerStore.customers;
	};

	useEffect(() => {
		const setTransactions = async () => {
			setLoading(true);
			await Promise.all([
				transactions(),
				transactionSummary(),
			]);
			setLoading(false);
		};
		setTransactions();
	}, []);
	const validationSchema = () => {
		return object({
			startDate: string().required('Start Date is required'),
			endDate: string().required('End Date is required'),
		});
	};

	const onSubmit = async payload => {
		let query;

		if (payload && Object.keys(payload).length > 0) {
			query = `startDate=${payload.startDate}&endDate=${payload.endDate}&dateField=createdAt`;
			if (payload.period === 'custom') {
				setFilterPeriod(
					`${moment(payload?.startDate).format('DD-MM-YYYY')} - ${moment(payload.endDate).format('DD-MM-YYYY')}`
				);
			} else {
				setFilterPeriod(`${payload?.periodText}`);
			}
		}
		setLoading(true);
		await Promise.all([
			TransactionsController.transactionSummary(query),
			TransactionsController.transactions(query),
		]);

		setLoading(false);
	};

	setCustomers();

	const logout = () => {
		userStore.setLoggedIn(false);
	};

	const [viewMoreExpense, setViewMoreExpense] = useState(false);
	const [viewMoreIncome, setViewMoreIncome] = useState(false);
	const [openTagModal, setOpenTagModal] = useState(false);

	const getExpensesModal = () => {
		// isOnboardingDone();
		setOpenExpensesModal(true);
	};

	const getIncomeModal = () => {
		// isOnboardingDone();
		setOpenIncome(true);
	};


	const closeModal = () => {
		setViewMoreExpense(false);
		setViewMoreIncome(false);
		setOpenTagModal(false);
	};

	const resetFilter = () => {
		onSubmit();
		setFilterPeriod(`${theYear}`);
	};
	const refresh = async () => {
		setLoading(true);
		await Promise.all([
			transactions(),
			transactionSummary(),
			CustomerController.getCustomers(),
		]);
		setLoading(false);
	};

	return (
		<Transactions
			summary={transactionStore.transactionsSummary}
			logout={logout}
			loading={loading}
			refresh={refresh}
			openExpensesModal={openExpensesModal}
			onSubmit={onSubmit}
			getExpensesModal={getExpensesModal}
			openIncome={openIncome}
			getIncomeModal={getIncomeModal}
			closeModal={closeModal}
			validationSchema={validationSchema}
			filterPeriod={filterPeriod}
			resetFilter={resetFilter}
			viewMoreExpense={viewMoreExpense}
			setViewMoreExpense={setViewMoreExpense}
			filterPeriods={filterPeriods}
			getDate={getDate}
			openTagModal={openTagModal}
			setOpenTagModal={setOpenTagModal}
			viewMoreIncome={viewMoreIncome}
			setViewMoreIncome={setViewMoreIncome}
		/>
	);
};

export default observer(TransactionsContainer);
